import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-pricing-plan',
  templateUrl: './dashboard-pricing-plan.component.html',
  styleUrls: ['./dashboard-pricing-plan.component.scss']
})
export class DashboardPricingPlanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
